export const NAME = 'shop';

export const REQUEST_PARTNER_SHOPS = 'REQUEST_PARTNER_SHOPS';
export const RECEIVE_PARTNER_SHOPS = 'RECEIVE_PARTNER_SHOPS';
export const FAILURE_PARTNER_SHOPS = 'FAILURE_PARTNER_SHOPS';



// WEBPACK FOOTER //
// ./src/services/shop/constants.js